var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._t("activator",null,{"on":_vm.onHandler}),_vm._v(" "),_c('div',{staticClass:"menu-popout",on:{"click":_vm.onContentClick}},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }